import React from 'react'

function OurClientSays() {
  return (
    <section class="wrapper custom-wrapper testimonial-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="block-title">What Our Client Says</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="owl-carousel" id="testimonial">
                    <div class="item">
                        <div class="client-box">
                            <div class="client-comment">The team got a hard task to deal with , they were very persistent and explained the problems on an understandable level. I can for sure recommend this team and I will most likely work with them again.Very much recommended.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/eshult.jpg" /></div>
                                <div class="client-name">
                                <h6>Eshult</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="client-box">
                            <div class="client-comment">Great job, everything was done as I wanted. Recommend!</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/jhonesmarcos.jpg" /></div>
                                <div class="client-name">
                                <h6>Jones Marcos</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="client-box">
                            <div class="client-comment">This is one of several projects that have been completed by TWS . I keep coming back to them for several reasons. 1. The work is excellent 2. The price is reasonable 3. Excellent communication 4. Revisions are never a problem I am sure I will be working with them on many more projects.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/client-3.jpg" /></div>
                                <div class="client-name">
                                <h6>Christine</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="client-box">
                            <div class="client-comment">Sanjoy and his team Tws are awesome. Work was perfect and communication was excellent. I finally found a team that knows how to get the job done. I will defitnitley use them again in the future . Great work guys</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/max.png" /></div>
                                <div class="client-name">
                                <h6>Max</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="client-box">
                            <div class="client-comment">Very nice guys to work with. They know what they're doing and nothing seems impossible. Thanks for this projects guys! Will hire again in the future.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/gabriel.jpg" /></div>
                                <div class="client-name">
                                <h6>Gabriel</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="client-box">
                            <div class="client-comment">I am very, very happy with the finished result from this project. I cannot praise Sanjoy? and Eddy ?and his team enough for the work they have done for me! Very good communication, I would recommend this team to anyone! Absolutely fantastic job Sanjoy.. thank you very much.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/paul.jpg" /></div>
                                <div class="client-name">
                                <h6>Paul</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                            
                            <div class="item">
                        <div class="client-box">
                            <div class="client-comment">First of all you can trust them for your projects. if you know what you want and if your blueprints is clear, they can do it easily. you can contact whenever they are always online. I will work with them again. Thank you.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/kursat.jpg" /></div>
                                <div class="client-name">
                                <h6>Kursat Kurkaya</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                            
                            <div class="item">
                        <div class="client-box">
                            <div class="client-comment">Quality results and professional touch. Easy to communicate. Looking forward working together again and again. Excellent job because the project finished on time and communication worked great. Great team.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/jussi.jpg" /></div>
                                <div class="client-name">
                                <h6>Sir Jussi</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                            <div class="item">
                        <div class="client-box">
                            <div class="client-comment">I just wanted to thank you for the excellent job you have done on our website. I am very pleased with the final product.</div>
                            <div class="client-dtl">
                                <div class="client-photo"><img alt="client name" src="assets/images/clients/mizan.jpg" /></div>
                                <div class="client-name">
                                <h6>Mizan ur Rahman</h6>
                                <p>Company name goes here</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default OurClientSays